import { useCallback } from 'react'

import { UrlStateStorageKeys } from 'modules/Monitoring/url-state-storage/consts'
import { useHashedSearchParams } from 'modules/Monitoring/url-state-storage/useHashedSearchParams'

import { useChannel } from './useChannel'

type SelectedChartsState = { selectedCharts: string[] }

const SELECTED_CHARTS_INITIAL_DATA: SelectedChartsState = {
  selectedCharts: [],
}

export const useSelectedCharts = (key: UrlStateStorageKeys) => {
  const { regionedChannel } = useChannel()

  const {
    state: { selectedCharts = [] },
    updateState,
  } = useHashedSearchParams<SelectedChartsState>({
    hashParamKey: key,
    initialState: SELECTED_CHARTS_INITIAL_DATA,
    contextKey: regionedChannel,
  })

  const handleChartsSelect = useCallback(
    (newSelectedCharts: string[]) => {
      updateState({ selectedCharts: newSelectedCharts })
    },
    [updateState],
  )

  return {
    selectedCharts,
    handleChartsSelect,
  }
}
